export const pricingData = [
  {
    id: 'software',
    name: 'Gen 3 Software',
    description: 'Required for all systems',
    wholesale: 99.99,
    retail: 99.99
  },
  {
    id: 'receiver',
    name: 'Receiver',
    description: 'Required for all systems',
    wholesale: 598.56,
    retail: 688.34
  },
  {
    id: 'chestTransmitter',
    name: 'Gen 3 Chest Guard Transmitter',
    description: '',
    wholesale: 399.44,
    retail: 459.35
  },
  {
    id: 'headTransmitter',
    name: 'Gen 3 Head Transmitter',
    description: '',
    wholesale: 484.22,
    retail: 556.85
  },
  {
    id: 'judgeBox',
    name: 'Judge Box',
    description: '',
    wholesale: 598.56,
    retail: 688.34
  },
  {
    id: 'headGuardXSRed',
    name: 'Gen 3 Head Guard - Size XS (Red)',
    description: '',
    wholesale: 399.99,
    retail: 399.99,
    category: 'headGuard'
  },
  {
    id: 'headGuardXSBlue',
    name: 'Gen 3 Head Guard - Size XS (Blue)',
    description: '',
    wholesale: 399.99,
    retail: 399.99,
    category: 'headGuard'
  },
  {
    id: 'headGuardSRed',
    name: 'Gen 3 Head Guard - Size S (Red)',
    description: '',
    wholesale: 399.99,
    retail: 399.99,
    category: 'headGuard'
  },
  {
    id: 'headGuardSBlue',
    name: 'Gen 3 Head Guard - Size S (Blue)',
    description: '',
    wholesale: 399.99,
    retail: 399.99,
    category: 'headGuard'
  },
  {
    id: 'headGuardMRed',
    name: 'Gen 3 Head Guard - Size M (Red)',
    description: '',
    wholesale: 399.99,
    retail: 399.99,
    category: 'headGuard'
  },
  {
    id: 'headGuardMBlue',
    name: 'Gen 3 Head Guard - Size M (Blue)',
    description: '',
    wholesale: 399.99,
    retail: 399.99,
    category: 'headGuard'
  },
  {
    id: 'headGuardLRed',
    name: 'Gen 3 Head Guard - Size L (Red)',
    description: '',
    wholesale: 399.99,
    retail: 399.99,
    category: 'headGuard'
  },
  {
    id: 'headGuardLBlue',
    name: 'Gen 3 Head Guard - Size L (Blue)',
    description: '',
    wholesale: 399.99,
    retail: 399.99,
    category: 'headGuard'
  },
  {
    id: 'headGuardXLRed',
    name: 'Gen 3 Head Guard - Size XL (Red)',
    description: '',
    wholesale: 399.99,
    retail: 399.99,
    category: 'headGuard'
  },
  {
    id: 'headGuardXLBlue',
    name: 'Gen 3 Head Guard - Size XL (Blue)',
    description: '',
    wholesale: 399.99,
    retail: 399.99,
    category: 'headGuard'
  },
  {
    id: 'chestGuardSize0Red',
    name: 'Gen 3 E-Chest Guard - Size 0 (Red)',
    description: '',
    wholesale: 706.01,
    retail: 847.22,
    category: 'chestGuard'
  },
  {
    id: 'chestGuardSize0Blue',
    name: 'Gen 3 E-Chest Guard - Size 0 (Blue)',
    description: '',
    wholesale: 706.01,
    retail: 847.22,
    category: 'chestGuard'
  },
  {
    id: 'chestGuardSize1Red',
    name: 'Gen 3 E-Chest Guard - Size 1 (Red)',
    description: '',
    wholesale: 706.01,
    retail: 847.22,
    category: 'chestGuard'
  },
  {
    id: 'chestGuardSize1Blue',
    name: 'Gen 3 E-Chest Guard - Size 1 (Blue)',
    description: '',
    wholesale: 706.01,
    retail: 847.22,
    category: 'chestGuard'
  },
  {
    id: 'chestGuardSize2Red',
    name: 'Gen 3 E-Chest Guard - Size 2 (Red)',
    description: '',
    wholesale: 726.29,
    retail: 871.55,
    category: 'chestGuard'
  },
  {
    id: 'chestGuardSize2Blue',
    name: 'Gen 3 E-Chest Guard - Size 2 (Blue)',
    description: '',
    wholesale: 726.29,
    retail: 871.55,
    category: 'chestGuard'
  },
  {
    id: 'chestGuardSize3Red',
    name: 'Gen 3 E-Chest Guard - Size 3 (Red)',
    description: '',
    wholesale: 726.29,
    retail: 871.55,
    category: 'chestGuard'
  },
  {
    id: 'chestGuardSize3Blue',
    name: 'Gen 3 E-Chest Guard - Size 3 (Blue)',
    description: '',
    wholesale: 726.29,
    retail: 871.55,
    category: 'chestGuard'
  },
  {
    id: 'chestGuardSize4Red',
    name: 'Gen 3 E-Chest Guard - Size 4 (Red)',
    description: '',
    wholesale: 748.55,
    retail: 898.26,
    category: 'chestGuard'
  },
  {
    id: 'chestGuardSize4Blue',
    name: 'Gen 3 E-Chest Guard - Size 4 (Blue)',
    description: '',
    wholesale: 748.55,
    retail: 898.26,
    category: 'chestGuard'
  },
  {
    id: 'chestGuardSize5Red',
    name: 'Gen 3 E-Chest Guard - Size 5 (Red)',
    description: '',
    wholesale: 748.55,
    retail: 898.26,
    category: 'chestGuard'
  },
  {
    id: 'chestGuardSize5Blue',
    name: 'Gen 3 E-Chest Guard - Size 5 (Blue)',
    description: '',
    wholesale: 748.55,
    retail: 898.26,
    category: 'chestGuard'
  }
];